module.exports = __webpack_public_path__ + "img/sass.93cf92a3.svg";